import * as styles from './index.module.scss';

const CountryHero = () => (
  <div className={`${styles['country-hero-container']}`}>
    <div className="container">
      <h1>We have a lot of listings</h1>
      <h2>For best results, we suggest choosing a location.</h2>
    </div>
  </div>
);

export default CountryHero;
